import { render, staticRenderFns } from "./TrainingMaterialDetailView.vue?vue&type=template&id=16a700f2&scoped=true"
import script from "./TrainingMaterialDetailView.vue?vue&type=script&lang=js"
export * from "./TrainingMaterialDetailView.vue?vue&type=script&lang=js"
import style0 from "./TrainingMaterialDetailView.vue?vue&type=style&index=0&id=16a700f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a700f2",
  null
  
)

export default component.exports